import allCases from '../../fields/cases/allCases';

export const QUERY_GET_ALL_D_CASES = /* GraphQL */ `
	query($limit: Float, $offset: Float, $filter: DepositCaseFilter, $notEqual: DepositCaseFilter) {
		getAllDepositCase(
			limit: $limit
			offset: $offset
			filter: $filter
			notEqual: $notEqual
		) {
			items {
				${allCases}
			}
			total
		}
	}
`;
